import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges, ViewChild } from '@angular/core';
import { FitAddon } from '@xterm/addon-fit';
import { Terminal } from '@xterm/xterm';

@Component({
  selector: 'app-chat-device-command-terminal',
  templateUrl: './chat-device-command-terminal.component.html',
  styleUrls: ['./chat-device-command-terminal.component.scss']
})
export class ChatDeviceCommandTerminalComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Input() lightMode = false;
  @Input() liveOutput: string | null = null;
  @Input() storedOutput = '';
  @ViewChild('terminalHost') terminalHost?: ElementRef<HTMLDivElement>;

  private fitAddon?: FitAddon;
  private resizeObserver?: ResizeObserver;
  private terminal?: Terminal;

  ngAfterViewInit(): void {
    this.initializeTerminal();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['lightMode'] && this.terminal) {
      this.terminal.options.theme = this.resolveTheme();
    }

    if ((changes['liveOutput'] || changes['storedOutput']) && this.terminal) {
      this.renderOutput();
    }
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
    this.terminal?.dispose();
  }

  private initializeTerminal(): void {
    if (!this.terminalHost?.nativeElement) {
      return;
    }

    this.terminal = new Terminal({
      convertEol: true,
      cursorBlink: false,
      disableStdin: true,
      fontFamily: 'Menlo, Monaco, Consolas, "Liberation Mono", monospace',
      fontSize: 12,
      lineHeight: 1.3,
      scrollback: 5000,
      theme: this.resolveTheme()
    });
    this.fitAddon = new FitAddon();
    this.terminal.loadAddon(this.fitAddon);
    this.terminal.open(this.terminalHost.nativeElement);
    this.fitAddon.fit();
    this.renderOutput();

    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(() => {
        this.fitAddon?.fit();
      });
      this.resizeObserver.observe(this.terminalHost.nativeElement);
    }
  }

  private renderOutput(): void {
    if (!this.terminal) {
      return;
    }

    this.terminal.reset();
    const output = this.liveOutput || this.storedOutput;

    if (!output) {
      this.terminal.writeln('Waiting for terminal output...');
      return;
    }

    this.terminal.write(output);
    this.terminal.scrollToBottom();
  }

  private resolveTheme() {
    if (this.lightMode) {
      return {
        background: '#f8fafc',
        foreground: '#0f172a',
        cursor: '#0f172a',
        selectionBackground: '#cbd5e1'
      };
    }

    return {
      background: '#020617',
      foreground: '#dbe4f0',
      cursor: '#f8fafc',
      selectionBackground: '#334155'
    };
  }
}